import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { useAlert } from "react-alert";

import { useDispatch, useSelector } from "react-redux";
import {
  getAdviceDetail,
  updateAdvice,
  clearErrors,
} from "../../../actions/adminAdviceActions";
import { UPDATE_ADVICE_RESET } from "./../../../constants/adminAdviceConstants";

import Loader from "../../Loader";

import "./Advice.css";

const EditAdvice = ({ history, match }) => {
  const alert = useAlert();
  const dispatch = useDispatch();

  const [adviceId, setAdviceId] = useState("");
  const [title, setTitle] = useState("");
  const [min_percentage, setMinPercentage] = useState("");
  const [max_percentage, setMaxPercentage] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState(false);

  const [errorData, setErrorData] = useState({});

  const { isUpdated, aloading, error, errors } = useSelector(
    (state) => state.adviceList
  );

  const currentItemId = match.params.id;
  useEffect(() => {
    dispatch(getAdviceDetail(currentItemId));
  }, [dispatch]);

  const { advice } = useSelector((state) => state.adviceDetail);

  useEffect(() => {
    if (errors) {
      setErrorData(errors);
    }

    if (advice) {
      setAdviceId(advice._id);
      setTitle(advice.title);
      setMinPercentage(advice.min_percentage);
      setMaxPercentage(advice.max_percentage);
      setDescription(advice.description);
      setStatus(advice.status);
    }
    if (error) {
      alert.error(error);
      dispatch(clearErrors());
    }
    if (isUpdated) {
      alert.success("Advice updated successfully");
      dispatch(getAdviceDetail(advice._id));
      history.push(`/admin/advice-list`);
      dispatch({
        type: UPDATE_ADVICE_RESET,
      });
    }
  }, [dispatch, advice, alert, error, errors, history, isUpdated]);

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(
      updateAdvice(
        adviceId,
        title,
        min_percentage,
        max_percentage,
        description,
        status
      )
    );
  };

  return (
    <Fragment>
      {aloading ? (
        <Loader />
      ) : (
        <Fragment>
          <div className="content-wrapper">
            <section className="content-header">
              <h1>
                Edit
                <small>Advice</small>
              </h1>
              <ol className="breadcrumb">
                <li>
                  <Link to="/admin">
                    <i className="fa fa-dashboard"></i> Dashboard
                  </Link>
                </li>
                <li>
                  <Link to="/admin/advice-list">
                    <i className="fa fa-table"></i> Advice
                  </Link>
                </li>
                <li className="active">Edit Advice</li>
              </ol>
            </section>

            <section className="content">
              <div className="box box-default">
                <div className="box-header with-border">
                  <h3 className="box-title">Edit Advice</h3>

                  {/*<div className="box-tools pull-right">

                                    </div>*/}
                </div>

                <form id="quickForm" onSubmit={submitHandler}>
                  <div className="box-body">
                    <div className="form-group row">
                      <div className="col-md-12">
                        <label htmlFor="title">Title</label>
                        <input
                          type="text"
                          name="title"
                          className="form-control"
                          id="title"
                          placeholder="Enter the advice title"
                          value={title}
                          onChange={(e) => setTitle(e.target.value)}
                        />
                        {errorData.title ? (
                          <span className="text-danger">{errorData.title}</span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label htmlFor="min_percentage">Min percentage</label>
                        <select
                          name="min_percentage"
                          className="form-control"
                          id="min_percentage"
                          placeholder="Enter the advice min percentage"
                          value={min_percentage}
                          onChange={(e) => {
                            setMinPercentage(e.target.value);
                            setMaxPercentage(e.target.value);
                          }}
                        >
                          <option value="">Min Value</option>
                          {[...Array(101)].map((_, i) => (
                            <option value={i}>{i}</option>
                          ))}
                        </select>
                        {errorData.min_percentage ? (
                          <span className="text-danger">
                            {errorData.min_percentage}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="max_percentage">Max percentage</label>
                        <select
                          name="max_percentage"
                          className="form-control"
                          id="max_percentage"
                          placeholder="Enter the advice max percentage"
                          value={max_percentage}
                          onChange={(e) => setMaxPercentage(e.target.value)}
                        >
                          <option value="">Max Value</option>
                          {[...Array(101)].map((e, i) => (
                            <option
                              disabled={min_percentage >= i ? true : false}
                              value={i}
                            >
                              {i}
                            </option>
                          ))}
                        </select>
                        {errorData.max_percentage ? (
                          <span className="text-danger">
                            {errorData.max_percentage}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-12">
                        <label htmlFor="description">Description</label>
                        <textarea
                          className="form-control"
                          id="description"
                          name="description"
                          placeholder="Enter the advice description"
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                        ></textarea>
                        {errorData.description ? (
                          <span className="text-danger">
                            {errorData.description}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-md-6">
                        <label htmlFor="status">Status</label>
                        <input
                          style={{ marginRight: "5px" }}
                          type="checkbox"
                          className="form-check-input"
                          id="status"
                          name="status"
                          checked={status}
                          value={status}
                          onChange={(e) => setStatus(!status)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="box-footer">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </section>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default EditAdvice;
